import "./select.css"
import Select from "./Select"
import SelectContent from "./SelectContent"
import SelectGroup from "./SelectGroup"
import SelectItem from "./SelectItem"
import SelectLabel from "./SelectLabel"
import SelectScrollDownButton from "./SelectScrollDownButton"
import SelectScrollUpButton from "./SelectScrollUpButton"
import SelectSeparator from "./SelectSeparator"
import SelectTrigger from "./SelectTrigger"
import SelectValue from "./SelectValue"

export type { SelectProps } from "./Select"
export type { SelectContentProps } from "./SelectContent"
export type { SelectGroupProps } from "./SelectGroup"
export type { SelectItemProps } from "./SelectItem"
export type { SelectLabelProps } from "./SelectLabel"
export type { SelectScrollDownButtonProps } from "./SelectScrollDownButton"
export type { SelectScrollUpButtonProps } from "./SelectScrollUpButton"
export type { SelectSeparatorProps } from "./SelectSeparator"
export type { SelectTriggerProps } from "./SelectTrigger"
export type { SelectValueProps } from "./SelectValue"
export default Object.assign(Select, {
  Content: SelectContent,
  Group: SelectGroup,
  Item: SelectItem,
  Label: SelectLabel,
  ScrollDownButton: SelectScrollDownButton,
  ScrollUpButton: SelectScrollUpButton,
  Separator: SelectSeparator,
  Trigger: SelectTrigger,
  Value: SelectValue,
})
